<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <router-link :to="{ name: 'missing.view', params: { id: missing.id }}">
          <v-card class="ma-2">
            <v-img :src="missing.image || images.logo" :lazy-src="missing.image" aspect-ratio="3"></v-img>

            <v-card-title primary-title>
              <router-link :to="{ name: 'missing.view', params: { id: missing.id }}">
                <h3 class="headline mb-0">{{missing.title}}</h3>
              </router-link>
            </v-card-title>
            <v-card-text>
              <div>{{missing.description}}</div>
            </v-card-text>
            <v-card-actions>
              <span class="icons-group">
                <span>
                  <v-icon>mdi-map-marker</v-icon>
                  {{missing.city}}
                </span>
                <span>
                  <v-icon>mdi-tag</v-icon>
                  {{missing.category}}
                </span>
              </span>
            </v-card-actions>
          </v-card>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      images: {
        logo: require("../../assets/logo.png")
      }
    };
  },
  props: {
    missing: null
  }
};
</script>

<style scoped>
.icons-group {
  display: flex;
  flex: 1;
  justify-content: space-between;
}
</style>